
<div class="card">
  <div class="card-header card-header-grey">
    <h4 class="card-title">
      Modifier mon profil
    </h4>
  </div>
  <br />
  <mat-tab-group color="accent">
    <!-- Doonées personelles :
  - Nom
  - Prénom
  - Mail
  - Date de Naissance
  -->
    <mat-tab label="Vos informations">
      <div class="row" style="margin-top:2rem;">
        <div class="col-md-12">
          <form>
            <div class="row">
              <div class="col-md-6" *ngIf="isAffich('civilite')">
                <mat-form-field [color]="param.color" appearance="legacy">
                  <mat-label>Civilité</mat-label>
                  <mat-select panelClass="example-panel-{{param.color}}" [(ngModel)]="_civilite" id="civilite" name="civilite" (ngModelChange)="onSubmitField()">
                    <mat-option value="">À Préciser</mat-option>
                    <mat-option value="Madame">Madame</mat-option>
                    <mat-option value="Monsieur">Monsieur</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-md-6" *ngIf="isAffich('tel_portable')">
                <mat-form-field [color]="param.color">
                  <mat-label>Téléphone portable</mat-label>
                  <input type="text" matInput value="{{ _portable }}" [pattern]="phoneNumber" name="portable" [(ngModel)]='_portable' placeholder="0607080901" (ngModelChange)="onSave('can_tel_mob', $event)" #portable="ngModel">
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div #name class="col-md-6" *ngIf="isAffich('nom')">
                <mat-form-field [color]="param.color">
                  <mat-label>Nom</mat-label>
                  <input type="text" matInput value="{{ _nom }}" name="nom" [(ngModel)]='_nom' placeholder="Martin" [ngModelOptions]="{standalone: true}" #nom>
                </mat-form-field>
              </div>
              <div class="col-md-6" *ngIf="isAffich('prenom')">
                <mat-form-field [color]="param.color">
                  <mat-label>Prénom</mat-label>
                  <input type="text" matInput value="{{ _prenom }}" name="prenom" [(ngModel)]='_prenom' placeholder="Jérémy" (ngModelChange)="onSave('can_prenom', $event)" #prenom>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6" *ngIf="isAffich('mail')">
                <mat-form-field [color]="param.color">
                  <mat-label>Adresse mail</mat-label>
                  <input type="email" matInput value="{{ _mail }}" name="mail" [pattern]="emailPattern" [(ngModel)]='_mail' placeholder="myname@test.fr" (ngModelChange)="onSave('can_mail', $event)" #email="ngModel">
                </mat-form-field>
              </div>

              <div class="col-md-6">
                <mat-form-field [color]="param.color">
                  <mat-label>Adresse mail 2</mat-label>
                  <input type="email" matInput value="{{ _mail2 }}" name="mail2" [pattern]="emailPattern" [(ngModel)]='_mail2' placeholder="myname@test.fr" (ngModelChange)="onSave('can_mail3', $event)" #email2="ngModel">
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6" *ngIf="isAffich('postal')">
                <mat-form-field [color]="param.color">
                  <mat-label>Code Postal</mat-label>
                  <input type="text" [(ngModel)]="_codepostal" [pattern]="postalPattern" matInput id="code_postal" name="code_postal" placeholder="ex: 31400" (ngModelChange)="onSave('can_codepostal', $event)" #code_postal="ngModel">
                  <!--<button id="edit-postal" mat-icon-button matSuffix (click)="onClick($event);lastValue=_codepostal" *ngIf="selected !== 'edit-postal'">
          <div class="icon"><mat-icon>edit</mat-icon></div>
        </button>
        <button id="valid-postal" mat-icon-button matSuffix [disabled]="code_postal.errors?.pattern" *ngIf="selected == 'edit-postal'" (click)="onSubmitField()"><div class="icon"><mat-icon>done</mat-icon></div></button>
        <button id="clear-postal" mat-icon-button (click)="onClear();_codepostal=lastValue;" matSuffix *ngIf="selected == 'edit-postal'"><div class="icon"><mat-icon>clear</mat-icon></div></button>-->
                </mat-form-field>
              </div>
              <div class="col-md-6" *ngIf="isAffich('pays')">
                <mat-form-field [color]="param.color">
                  <mat-label>Pays</mat-label>
                  <input type="text" matInput id="pays" [(ngModel)]="_pays" name="pays" placeholder="" (ngModelChange)="onSave('can_pays', $event)" #pays>
                  <!--<button id="edit-pays" mat-icon-button matSuffix (click)="onClick($event);lastValue=_pays" *ngIf="selected !== 'edit-pays'">
          <div class="icon"><mat-icon>edit</mat-icon></div>
        </button>
        <button id="valid-pays" mat-icon-button matSuffix *ngIf="selected == 'edit-pays'" (click)="onSubmitField()"><div class="icon"><mat-icon>done</mat-icon></div></button>
        <button id="clear-pays" mat-icon-button (click)="onClear();_pays=lastValue" matSuffix *ngIf="selected == 'edit-pays'"><div class="icon"><mat-icon>clear</mat-icon></div></button>-->
                </mat-form-field>
              </div>
            </div>

          </form>
        </div>
      </div>
    </mat-tab>
    
    <!------- mat------------------------------------------------------------------------>
    <mat-tab label="Votre expérience">
      <div class="row" style="margin-top:2rem;">
        <div class="col-md-12">
          <form>

            <div class="row">
              <div class="col-md-6">
                <mat-form-field [color]="param.color" appearance="legacy">
                  <mat-label>Fonctions exercées</mat-label>
                  <mat-select panelClass="example-panel-{{param.color}}" [(ngModel)]="fonctionName" (ngModelChange)="onSave('fonctions', $event)" name="fonction" multiple>
                    <mat-option *ngFor="let fonction of emploiFonction" [value]="fonction.fonction">{{fonction.fonction}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <p>
                  <mat-form-field [color]="param.color" appearance="legacy">
                    <mat-label>Secteurs principaux où vous avez travaillé</mat-label>
                    <mat-select panelClass="example-panel-{{param.color}}" [(ngModel)]="secteurActiviteName" (ngModelChange)="onSave('secteurActivites', $event)" name="secteurActivite" multiple>
                      <mat-option *ngFor="let secteurActivite of profilSecteur" [value]="secteurActivite.secteur_activite">{{secteurActivite.secteur_activite}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </p>
              </div>
            </div>
          </form>
        </div>
      </div>


      <div class="row" style="margin-top:2rem;">
        <div class="col-md-12">
          <form>
            <div class="row">

              <!--<div class="col-md-6">
                <mat-form-field [color]="param.color" appearance="legacy">
                  <mat-label>Fonctions exercées</mat-label>
                  <mat-select panelClass="example-panel-{{param.color}}" [(ngModel)]="fonctionName" (ngModelChange)="onSave('fonctions', $event)" name="fonction" multiple>
                    <mat-option *ngFor="let fonction of emploiFonction" [value]="fonction.fonction">{{fonction.fonction}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>-->



              <div class="col-md-6">
                <mat-form-field [color]="param.color" appearance="legacy">
                  <mat-label>Type d'entreprise où vous avez principalement exercé</mat-label>
                  <mat-select panelClass="example-panel-{{param.color}}" [(ngModel)]="typeentrepriseName" name="typeentreprise" (ngModelChange)="onSave('typeentreprises', $event)" multiple>
                    <mat-option *ngFor="let typeentreprise of profil_typeentreprise" [value]="typeentreprise.typeentreprises">{{typeentreprise.typeentreprises}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="col-md-6">
                <mat-form-field [color]="param.color" appearance="legacy">
                  <mat-label>Taille des effectifs managés</mat-label>
                  <mat-select panelClass="example-panel-{{param.color}}" [(ngModel)]='effectifsmanagesName' (ngModelChange)="onSave('effectifsmanages', $event)" name="effectifsmanage" multiple>
                    <mat-option *ngFor="let effectifsmanages of profilEffectifsManagement" [value]="effectifsmanages.effectifs_management_taille">{{effectifsmanages.effectifs_management_taille}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

            </div>
          </form>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Vos compétences">
      <div class="row" style="margin-top:2rem;">
        <div class="col-md-12">
          <form>
            <div class="row">
              <div class="col-md-6">
                <p>
                  <mat-form-field [color]="param.color" appearance="legacy">
                    <mat-label>Compétences</mat-label>
                    <mat-select panelClass="example-panel-{{param.color}}" [(ngModel)]="competenceName" (ngModelChange)="onSave('competences', $event)" name="competence" multiple>
                      <mat-option *ngFor="let competences of profil_competence" [value]="competences.competence">{{competences.competence}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </p>
              </div>



              <div #name class="col-md-6">
                <mat-form-field [color]="param.color">
                  <mat-label>Expertises spécifiques (Mots-clés séparés par des virgules)</mat-label>
                  <input type="text" matInput value="{{ _profil_cles }}" name="profil_cles" [(ngModel)]='_profil_cles' placeholder="Exemple: ISO 40704" (ngModelChange)="onSave('profil_cles', $event)">
                </mat-form-field>
              </div>



            </div>
            <div class="row">


              <div class="col-md-6">
                <p>
                  <mat-form-field [color]="param.color" appearance="legacy">
                    <mat-label>Pays dans lesquels vous avez travaillé</mat-label>
                    <mat-select panelClass="example-panel-{{param.color}}" [(ngModel)]="paystravailName" (ngModelChange)="onSave('paystravail', $event)" name="paystravaille" multiple>
                      <mat-option *ngFor="let paystravail of paystravaille" [value]="paystravail.paystravail">{{paystravail.paystravail}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </p>
              </div>
              <div class="col-md-6" *ngIf="isAffich('langues')">
                <form [formGroup]="patientCategory">
                  <mat-form-field [color]="param.color">
                    <mat-label>Langues</mat-label>
                    <mat-select formControlName="skalls" [compareWith]="compareObjects" (ngModelChange)="onSave('langues', $event)" panelClass="example-panel-{{param.color}}" multiple>
                      <mat-option *ngFor="let langue of langues" [hidden]="langue.idcompetence_langue == 0" [value]="{ Id : langue.idcompetence_langue, Name : langue.competence_langue_nom, Niveau: 0, Hover: 0}">{{langue.competence_langue_nom}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </form>
                <div class="col-md-6 mb-2">
                  <div class="row mb-2" *ngFor="let langue of skills">
                    <div class="col-4"><b>{{ langue.Name }}</b></div>
                    <div class="col-8">
                      <div class="row">
                        <span *ngFor="let nvlg of niveauLangue"
                              [hidden]="nvlg.idniveau == 0"
                              (mouseenter)="langue.Hover = nvlg.idniveau"
                              (mouseleave)="langue.Hover = 0"
                              (click)="langue.Niveau = nvlg.idniveau;onSave('nivLangue', langue)"
                              class="rating-container"
                              style="cursor: pointer;"
                              [matTooltip]="nvlg.niveau"
                              matTooltipPosition="above"
                              matTooltipClass="example-tooltip-red">
                          <span [class]=" langue.Niveau >= nvlg.idniveau || langue.Hover >= nvlg.idniveau ? 'star-selected' : 'star' ">
                            &#9733;
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>

          </form>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="Votre future mission">
      <div class="row" style="margin-top:2rem;">
        <div class="col-md-12">
          <form>

            <div class="row">
              <div class="col-md-6">
                <p>
                  <mat-form-field [color]="param.color" appearance="legacy">
                    <mat-label>Mobilité</mat-label>
                    <mat-select panelClass="example-panel-{{param.color}}" [(ngModel)]="regionName" (ngModelChange)="onSave('regions', $event)" name="region" multiple>
                      <mat-option *ngFor="let regions of region" [value]="regions.region">{{regions.region}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </p>
              </div>


            </div>
            <div class="row">
    <div #name class="col-md-6">
      <mat-form-field [color]="param.color">
        <mat-label>Prétentions Tarif journalier (TJM) €/jour</mat-label>
        <input [(ngModel)]="_salaire_jour" (ngModelChange)="onSave('profil_salaire_jour', $event)" [ngModelOptions]="{standalone: true}" matInput pattern="^[0-9]*$" placeholder="€/jour">
      </mat-form-field>
    </div>
    <div #name class="col-md-6">
      <mat-form-field [color]="param.color">
        <mat-label>Prétentions brut annuel k€/an</mat-label>
        <input [(ngModel)]="_salaireMin" (ngModelChange)="onSave('profil_salaire_inf', $event)" [ngModelOptions]="{standalone: true}" matInput pattern="^[0-9]*$" placeholder="k€/an">
      </mat-form-field>
    </div>
  </div>

          </form>






        </div>
      </div>
    </mat-tab>
    <mat-tab label="Votre autres informations">
      <div class="row" style="margin-top:2rem;">
        <div class="col-md-12">
          <form>
            <div class="row">
              <div class="col-md-12">

                <mat-form-field [color]="param.color">
                  <mat-label>Autres informations (facultatif)</mat-label>
                  <input [(ngModel)]="_profil_mail_accompagnement" (ngModelChange)="onSave('profil_mail_accompagnement', $event)" matInput [ngModelOptions]="{standalone: true}" placeholder="Décrivez les informations que vous souhaitez nous transmettre...">
                </mat-form-field>
              </div>

            </div>

          </form>






        </div>
      </div>
    </mat-tab>





  </mat-tab-group>
</div>
